import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { MenuCartComponent } from './menu-cart.component';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      cmsComponents: {
        MenuCartComponent: {
          component: MenuCartComponent,
        },
      },
    }),
  ],
})
export class MenuCartModule {}
